<div class="flex w-full flex-col items-center justify-center gap-6 p-6 md:flex-row md:items-stretch md:gap-4 md:px-6 md:py-10 lg:p-12">
  <div class="flex w-full max-w-md flex-col rounded-lg border border-stone-50 px-4 py-6 shadow-lg md:w-1/2 lg:px-10 lg:py-12">
    <div class="flex-1">
      <h5 class="text-3xl leading-loose">
        {{ 'login.user.title' | transloco }}
      </h5>
      <p>
        {{ 'login.user.subTitle' | transloco }}
      </p>
      <p-button
        severity="contrast"
        size="large"
        (onClick)="loginWithProPoints()"
        data-testid="user-login-button"
        [label]="'login.user.buttonContent' | transloco"
        styleClass="w-full my-8" />
    </div>

    <a [attr.href]="registrationUrl">
      {{ 'login.user.footer' | transloco }}
    </a>
  </div>

  <div class="flex w-full max-w-md flex-col rounded-lg border border-stone-50 px-4 py-6 shadow-lg md:w-1/2 lg:px-10 lg:py-12">
    <div class="flex-1">
      <h5 class="text-3xl leading-loose">
        {{ 'login.device.title' | transloco }}
      </h5>
      <p>
        {{ 'login.device.subTitle' | transloco }}
      </p>
      <form [formGroup]="form" class="mt-8 flex flex-col gap-6">
        <p-floatlabel variant="on" class="w-full">
          <input pInputText pSize="large" id="zipCode" formControlName="zipCode" class="w-full" data-testid="zip-input" />
          <label for="zipCode">{{ 'login.device.zipPlaceholder' | transloco }}</label>
        </p-floatlabel>

        <p-floatlabel variant="on" class="w-full">
          <input pInputText pSize="large" id="code" formControlName="code" class="w-full" data-testid="code-input" />
          <label for="code">{{ 'login.device.codePlaceholder' | transloco }}</label>
        </p-floatlabel>
      </form>

      @if (form.errors) {
        <p class="text-red-500" data-testid="login-device-error">
          {{ 'login.device.error' | transloco }}
        </p>
      }

      <p-button
        severity="contrast"
        size="large"
        (onClick)="loginWithCode()"
        [disabled]="form.invalid"
        data-testid="device-login-button"
        [label]="'login.device.loginButton' | transloco"
        styleClass="mt-4 w-full" />
    </div>
  </div>
</div>
